import { useContext } from "react";
import { useController } from "react-hook-form";
import { FormContext } from "components/shared/Form";
import { Checkbox } from "components/ui/atoms/Checkbox";

export const RHFCheckbox = ({ name, ...props }) => {
  const {
    form: { control },
  } = useContext(FormContext);

  const { field, fieldState } = useController({
    control: control,
    name: name,
  });

  return (
    <Checkbox
      {...field}
      {...props}
      name={name}
      helperText={fieldState.error?.message}
      error={fieldState.invalid}
    />
  );
};

export default RHFCheckbox;
